import React, { useState, useEffect } from "react";

import { useMutation, gql } from "@apollo/client";

import axios from "axios";
import { server } from "../../../utills/utils";

import Brand from "./Brand";
import Modal from "../../Modals/ProductModal";
import Spinner from "../../Modals/SpinnerModal";

import styled from "styled-components";

const UPLOAD_FILE = gql`
  mutation uploadToAws($file: Upload!) {
    uploadToAws(file: $file) {
      url
    }
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
const AllBrand = styled.div`
  width: 103%;
  height: 85%;
  display: flex;
  margin-top: 2%;
  flex-flow: wrap;
  overflow-y: scroll;
`;

const Header = styled.div`
  width: 100%;
  height: 10%;
`;
const HeaderTitle = styled.h2`
  float: left;
  width: 60%;
  margin: 0;
  padding: 0;
`;
const AddButton = styled.button`
  float: right;
  padding: 12px 30px;
  font-size: 15px;
  border: 1px solid #eee;
  cursor: pointer;
  background: white;
`;
const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #f97a7a;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;
const AddTitele = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  font-weight: 500;
  color: #f97a7a;
`;
const ImageView = styled.div`
  width: 100%;
  height: 200px;
`;

const UploadButton = styled.div`
  width: 20%;
  float: left;
  text-align: center;
  padding-top: 40px;
  cursor: pointer;
`;

const ImagePreview = styled.div`
  width: 35%;
  height: 100%;
  background: #f8f8f8;
  float: right;
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
`;

const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
`;

function Brands() {
  const [brands, setBrands] = useState([]);
  const [complete, setComplete] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [brandImage, setBrandImage] = useState('');
  const [uploadDone, setUploadDone] = useState(false);
  const [name, setName] = useState('');
  const [spinner, setSpinner] = useState(false);

  const addModalHandler = () => {
    setAddModal(!addModal);
  };

  const fetchBrands = async () => {
    try {
      const brands = await axios.post(server, {
        query: `
                      query{
                          brands{
                              _id
                              name
                              image
                          }
                      }
                   `,
      });
      setBrands(brands.data.data.brands);
      setComplete(true);
      console.log("Brands", brands);
    } catch (error) {
      console.log(error);
    }
  };

  const addBrandHandler = async(e) =>{
      try{
          e.preventDefault();
          if(name && brandImage){
              setSpinner(true);
              const brand = await axios.post(
                  server,
                  {
                      query:`
                         mutation{
                            createBrand(name:"${name}", image:"${brandImage}"){
                                _id
                                name
                                image
                             }
                         }
                      `
                  }
              );
            if(brand.data.data && brand.data.data.createBrand){
                setBrands(brand.data.data.createBrand);
                setAddModal(false);
                setName('');
                setBrandImage('');
            }
            setSpinner(false);
          }
      }catch(error){
          console.log(error);
      }
     console.log(brandImage, name);
  }
  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const handleFileChange = (e) => {
    const files = e.target.files;
    // setTotalImages(e.target.files.length);
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      uploadToAws({ variables: { file } });
    }
  };

  const [uploadToAws] = useMutation(UPLOAD_FILE, {
    onCompleted: (data) => {
      console.log(data);
      setBrandImage(data.uploadToAws.url);
      setUploadDone(true);
      // const newImages = images;
      // newImages.push(data.uploadToAws.url);
      // setImages(newImages);
      // console.log("Images", allImages);
      // setImage(data.uploadToAws.url);
      // const allImages=[];
      // allImages.push(data.uploadToAws.url);
      // setImages(allImages);
    },
  });

  useEffect(() => {
    fetchBrands();
  }, []);
  return (
    <Container>
     <Spinner show={spinner}/>
      <Modal show={addModal} closeModal={addModalHandler}>
      <div style={{ padding: "2%" }}>
          <AddTitele>Add brand</AddTitele>
          <form onSubmit={addBrandHandler}>
            <ImageView>
              <UploadButton>
                <label for="file-input">
                  <img
                    style={{ width: "70px", height: "70px" }}
                    src="https://icon-library.net/images/upload-photo-icon/upload-photo-icon-21.jpg"
                  />
                </label>
                <input
                  id="file-input"
                  className="custom-file-input"
                  required="true"
                  type="file"
                  onChange={handleFileChange}
                  accept="image/x-png,image/gif,image/jpeg"
                />
              </UploadButton>
              <ImagePreview>
                {uploadDone ? (
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src={brandImage}
                    alt="productimage"
                  />
                ) : null}
              </ImagePreview>
            </ImageView>

            <Input
              value={name}
              onChange={nameChangeHandler}
              required="true"
              type="text"
              placeholder="Brand name"
            />
            <Button type="submit">Add</Button>
          </form>
        </div>
      </Modal>
      <Header>
        <HeaderTitle>Brands</HeaderTitle>
        <AddButton onClick={addModalHandler}>Add Brand</AddButton>
      </Header>

      {complete ? (
        brands && brands.length > 0 ? (
          <AllBrand>
            {
                brands.map(brand=>{
                    return<Brand key={brand._id} brand={brand}/>
                })
            }
          </AllBrand>
        ) : (
          <p>No brands found!</p>
        )
      ) : (
        <p>Loading....</p>
      )}
    </Container>
  );
}

export default Brands;
